import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';

const useMandatoryTextStyles = makeStyles(theme => ({
  root: {
    fontSize  : '12px',
    fontWeight: '400',
    '&>span'  : {
      color: theme.palette.primary.main,
    },
  },
}));

const MandatoryText = () => {
  const classes = useMandatoryTextStyles();

  return (
    <Typography className={classes.root}>
      <span>*</span>
      {' '}
      Mandatory information
    </Typography>
  );
};

export default MandatoryText;
